import { useEffect, useState } from 'react';

const badgeOverrideStyles = `
.badge-subtle-success, .badge.bg-success, .badge.text-bg-success {
  background-color: transparent !important;
  color: #16a34a !important;
  border: 1.5px solid #16a34a !important;
}

.badge-subtle-warning, .badge.bg-warning, .badge.text-bg-warning {
  background-color: transparent !important;
  color: #d97706 !important;
  border: 1.5px solid #d97706 !important;
}

.badge-subtle-danger, .badge.bg-danger, .badge.text-bg-danger {
  background-color: transparent !important;
  color: #dc2626 !important;
  border: 1.5px solid #dc2626 !important;
}

.badge-subtle-info, .badge.bg-info, .badge.text-bg-info {
  background-color: transparent !important;
  color: #2563eb !important;
  border: 1.5px solid #2563eb !important;
}

.badge-subtle-primary, .badge.bg-primary, .badge.text-bg-primary {
  background-color: transparent !important;
  color: #6d28d9 !important;
  border: 1.5px solid #6d28d9 !important;
}

.badge-subtle-secondary, .badge.bg-secondary, .badge.text-bg-secondary {
  background-color: transparent !important;
  color: #475569 !important;
  border: 1.5px solid #475569 !important;
}

.badge-subtle-dark, .badge.bg-dark, .badge.text-bg-dark {
  background-color: transparent !important;
  color: #1e293b !important;
  border: 1.5px solid #1e293b !important;
}

.badge-subtle-light, .badge.bg-light, .badge.text-bg-light {
  background-color: transparent !important;
  color: #64748b !important;
  border: 1.5px solid #64748b !important;
}
`;

const useToggleStylesheet = (isRTL, isDark) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    Array.from(document.getElementsByClassName('theme-stylesheet')).forEach(
      link => link.remove()
    );
    const link = document.createElement('link');
    link.href = `${process.env.PUBLIC_URL}/css/theme${isRTL ? '.rtl' : ''}.css`;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.className = 'theme-stylesheet';

    const userLink = document.createElement('link');
    userLink.href = `${process.env.PUBLIC_URL}/css/user${
      isRTL ? '.rtl' : ''
    }.css`;
    userLink.type = 'text/css';
    userLink.rel = 'stylesheet';
    userLink.className = 'theme-stylesheet';

    const badgeOverrideTag = document.createElement('style');
    badgeOverrideTag.className = 'theme-stylesheet';
    badgeOverrideTag.textContent = badgeOverrideStyles;

    link.onload = () => {
      setIsLoaded(true);
    };

    document.getElementsByTagName('head')[0].appendChild(link);
    document.getElementsByTagName('head')[0].appendChild(userLink);
    document.getElementsByTagName('head')[0].appendChild(badgeOverrideTag);
    document
      .getElementsByTagName('html')[0]
      .setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  }, [isRTL]);

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-bs-theme',
      isDark ? 'dark' : 'light'
    );
  }, []);

  return { isLoaded };
};

export default useToggleStylesheet;
